module.exports = __webpack_public_path__ + "static/img/4-2.1f6880d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/4-2.png
// module id = bYHY
// module chunks = 1